var processors = [
  require('./text/date'),
  require('./text/email'),
  require('./text/numeric'),
  require('./text/swearing'),
  require('./text/currencies'),
  require('./text/character_number'),
  require('./text/dictionary')
];

module.exports = {
  updateContent: function (element, data) {
    var restrictionsFacade = require('../../../restrictions/restrictions');
    var getRestrictions = _.partial(
      restrictionsFacade.getElementRestrictions,
      element.getAttribute('id')
    );

    try {
      var newContent = data['content'];
      var oldContent = this.textarea.text.textContent;

      _.each(processors, function (processor) {
        newContent = processor(getRestrictions, newContent);
      });

      var firstDiffLinePosition = null;

      var stringDifference = INKIVE.Tool.calculateStringContentDifference(oldContent, newContent);

      var newLetters = stringDifference.added - stringDifference.removed;
      var forceRedraw = data['force_redraw'] || newLetters <= 0 || newContent.length < 300;
      var cursorPosition = data['cursor_position'];
      var newContentStrings = newContent.split('\n');

      forceRedraw || _.any(this.textarea.text.strings, _.bind(function (string, index) {
        var textString = string.isBlank ? '' : string.textContent;
        var lastPosition = this.textarea.text.strings.length - 1;
        var isDiff = string.isEol ? newContentStrings[index] !== textString :
          newContentStrings[index].indexOf(textString) === -1;

        if (isDiff || index === lastPosition || index === newContentStrings.length - 1) {
          firstDiffLinePosition = index;
          return true;
        }
      }, this));

      this.textarea.setValues({ typing: !!data.typing });
      this.textarea.text.setValues({
        'firstDiffLinePosition': firstDiffLinePosition,
        'textContent': newContent.replace(/ /g, String.fromCharCode(160)),
        'oldContent': oldContent,
        'newLetters': newLetters,
        'cursorPosition': cursorPosition || (cursorPosition === 0 ? cursorPosition : null)
      });

      this.trigger('content', element.getAttribute('id'), newContent);
    } catch (err) {
      var advice = require('../../../../utils/advice');
      err = _.isArray(err) ? err : [err];
      _.each(err, function (e) {
        advice.show('restriction-text-' + e.message.replace(/_/g, '-'), e.params);
      });
    }
  },

  contentCompliesWithRestrictions: function (content, restrictions) {
    var getRestrictions = function (type) {
      return _.compact([restrictions[type]]);
    };

    try {
      var value = content.replace(/ /g, String.fromCharCode(160));
      _.each(processors, function (processor) {
        value = processor(getRestrictions, value);
      });
      return true;
    } catch (err) {
      return false;
    }
  }
};
